/* Frikytopia · seguimiento propio de navegación.
 *
 * Manda al panel qué páginas se están viendo, para poder ver quién pasa por la
 * web y se va sin comprar. GA4 no da esto: solo agregados, nunca quién.
 *
 * REGLAS QUE SE RESPETAN AQUÍ:
 *   1. Si el visitante ha rechazado las cookies de análisis, NO se manda nada.
 *      Se pregunta a la API de privacidad de Shopify, que es la que conoce su
 *      decisión.
 *   2. No se toca el proceso de pago ni el área de cuenta: ahí es donde el
 *      cliente escribe dirección y tarjeta.
 *   3. Del origen solo se guarda el dominio, nunca la URL completa con sus
 *      parámetros (que suelen llevar identificadores de campaña y a veces correo).
 *   4. El identificador de sesión es aleatorio y vive en sessionStorage: se borra
 *      al cerrar la pestaña y no sirve para seguir a nadie entre visitas.
 */
(function () {
  'use strict';
  var API = window.FRIKY_VISITAS_API || 'https://frikyshop.fly.dev/api/visitas-public';

  // 2 · Fuera del pago y de la cuenta.
  var ruta = location.pathname || '/';
  if (/\/(checkouts?|account|challenge|tools|admin)\b/i.test(ruta)) return;

  // 1 · Consentimiento. Si Shopify dice que no hay permiso para analítica, se
  // acabó. Si la API no existe (tema sin banner), se asume permiso: es el mismo
  // criterio que ya aplica la tienda con el resto de su analítica.
  function permitido() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return true;
      return cp.analyticsProcessingAllowed() !== false;
    } catch (e) { return true; }
  }

  // 4 · Identificador de sesión, aleatorio y efímero.
  function sid() {
    try {
      var k = 'friky_sid', v = sessionStorage.getItem(k);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return ''; }
  }

  // Qué tipo de página es, leyéndolo de la propia ruta.
  function tipo() {
    if (/^\/products\//.test(ruta)) return 'product';
    if (/^\/collections\/[^/]+\/products\//.test(ruta)) return 'product';
    if (/^\/collections\//.test(ruta)) return 'collection';
    if (/^\/blogs\//.test(ruta)) return 'article';
    if (/^\/pages\//.test(ruta)) return 'page';
    if (/^\/search/.test(ruta)) return 'search';
    if (/^\/cart/.test(ruta)) return 'cart';
    if (ruta === '/' || ruta === '') return 'index';
    return 'otra';
  }
  function handle() {
    var m = ruta.match(/\/(products|collections|blogs|pages)\/([^/?#]+)/);
    return m ? decodeURIComponent(m[2]) : '';
  }
  // 3 · Del origen, solo el dominio.
  function origen() {
    try {
      if (!document.referrer) return '';
      var u = new URL(document.referrer);
      if (u.hostname === location.hostname) return '';   // navegación interna: no es origen
      return u.hostname;
    } catch (e) { return ''; }
  }

  /* ── Contador de aceptación del banner de cookies ────────────────────────
   * Esto NO es seguimiento: no manda identificador de sesión, ni de cliente, ni
   * la página. Solo suma uno al recuento del día según lo que haya decidido el
   * visitante, para saber si el consentimiento nos cuesta visitas de verdad.
   * Por eso se manda también cuando ha dicho que NO.
   *
   * Se cuenta por CARGA DE PÁGINA, no por visitante: dedupe exigiría guardar
   * una marca en el navegador, y a quien ha rechazado no se le guarda nada.
   * Ambos grupos se miden igual, así que la proporción es comparable. */
  function contarConsentimiento() {
    var estado = 'sin_respuesta';
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        var a = String(c.analytics || c.analytics_processing_allowed || '').toLowerCase();
        var m = String(c.marketing || '').toLowerCase();
        if (a === 'yes' && m === 'yes') estado = 'aceptado';
        else if (a === 'no' && m === 'no') estado = 'rechazado';
        else if (a === 'yes' || m === 'yes') estado = 'parcial';
        else if (a === 'no' || m === 'no') estado = 'rechazado';
      } else if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        estado = cp.analyticsProcessingAllowed() ? 'aceptado' : 'rechazado';
      }
    } catch (e) { return; }
    var cuerpo = JSON.stringify({ estado: estado });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API + '/consentimiento', cuerpo)) return;
    } catch (e) { /* sigue */ }
    try { fetch(API + '/consentimiento', { method: 'POST', body: cuerpo, keepalive: true, mode: 'cors' }).catch(function () {}); } catch (e) {}
  }

  /* ── Identificación desde un enlace de nuestro correo ─────────────────────
   * El correo trae ?fk=<testigo firmado>. Al llegar, la sesión deja de ser
   * anónima — también lo que ya hubiera mirado antes en esa misma sesión.
   * El testigo se BORRA de la barra de direcciones en cuanto se usa: si no, el
   * cliente podría compartir la URL y quien la abriera quedaría apuntado como
   * él. */
  function identificar() {
    if (!permitido()) return;              // sin permiso no se ata nada a nadie
    var t = '';
    try { t = new URLSearchParams(location.search).get('fk') || ''; } catch (e) { return; }
    if (!t) return;
    var s = sid(); if (!s) return;
    try {
      fetch(API + '/id', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid: s, token: t }), mode: 'cors'
      }).catch(function () {});
    } catch (e) { /* sigue */ }
    try {
      var u = new URL(location.href); u.searchParams.delete('fk');
      history.replaceState(null, '', u.pathname + (u.search || '') + (u.hash || ''));
    } catch (e) { /* si el navegador no deja, no pasa nada grave */ }
  }

  function enviar() {
    if (!permitido()) return;
    var s = sid();
    if (!s) return;
    var datos = {
      sid: s,
      cid: window.FRIKY_CUSTOMER_ID || null,
      path: ruta,
      title: (document.title || '').replace(/\s*[|–-]\s*Frikytopia.*$/i, '').slice(0, 160),
      tipo: tipo(),
      handle: handle(),
      ref: origen()
    };
    var cuerpo = JSON.stringify(datos);
    // sendBeacon no bloquea la navegación ni se pierde si el cliente cambia de
    // página al instante, que es justo lo que pasa cuando alguien va rebotando
    // entre fichas.
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API + '/beacon', cuerpo)) return;
    } catch (e) { /* sigue por fetch */ }
    try {
      fetch(API + '/hit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: cuerpo, keepalive: true, mode: 'cors'
      }).catch(function () {});
    } catch (e) { /* la web nunca debe romperse por esto */ }
  }

  // Se manda una vez por página. Si el tema navega sin recargar, se detecta el
  // cambio de ruta y se manda de nuevo.
  //
  // El banner de Shopify tarda un momento en resolver el consentimiento: si se
  // preguntara al instante, saldría «sin respuesta» para todo el mundo. Por eso
  // el recuento y la identificación esperan un poco.
  /* ── De qué pop-up viene un alta del club ─────────────────────────────────
   * El pop-up marca su enlace de registro con ?fclub=<pieza>. Aquí se guarda al
   * pasar por la URL y se manda cuando el visitante YA es cliente — que es
   * varios pasos después: ve el pop-up, pincha, rellena el registro y vuelve.
   *
   * El servidor comprueba contra Shopify que el alta sea reciente antes de
   * apuntarla, así que un cliente viejo que pase por una URL con ?fclub= no
   * cuenta como alta nueva. */
  var K_ORIGEN = 'friky_club_origen';
  function origenClub() {
    var g = null;
    try {
      var m = new URLSearchParams(location.search).get('fclub');
      if (m) {
        localStorage.setItem(K_ORIGEN, m);
        var u = new URL(location.href); u.searchParams.delete('fclub');
        history.replaceState(null, '', u.pathname + (u.search || '') + (u.hash || ''));
      }
      g = localStorage.getItem(K_ORIGEN);
    } catch (e) { return; }
    var cid = window.FRIKY_CUSTOMER_ID;
    if (!g || !cid) return;               // aún no se ha registrado: se espera
    try {
      fetch(API + '/alta-origen', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cid: cid, origen: g }), mode: 'cors'
      }).then(function () {
        // Una vez apuntado, fuera: no debe volver a mandarse en cada página ni
        // reaparecer si el mismo navegador registra otra cuenta más adelante.
        try { localStorage.removeItem(K_ORIGEN); } catch (e) {}
      }).catch(function () {});
    } catch (e) {}
  }

  function arrancar() {
    enviar();
    identificar();
    origenClub();
    setTimeout(contarConsentimiento, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  var ultima = ruta;
  setInterval(function () {
    if (location.pathname !== ultima) { ultima = location.pathname; ruta = ultima; enviar(); }
  }, 1200);
})();
